import LegScreen from "./index";

const routes = [
  {
    path: "/leg/:id",
    component: LegScreen,
  },
];

export default routes;
